import React from 'react';
import postal from 'postal';

import * as styles from './styles/styles.module.scss';

import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const MobileExploreMapSwitch = createReactClass({
  getInitialState() {
    return {
      listView: !this.props.showMapMobile
    };
  },
  componentWillMount() {
    this.props.messagingChannel.subscribe('map.show', () => this.setState({ listView: false }));
    this.props.messagingChannel.subscribe('map.hide', () => this.setState({ listView: true }));
  },
  handleClick() {
    this.props.messagingChannel.publish(this.state.listView ? 'map.show' : 'map.hide');
    this.setState({ listView: !this.state.listView });
  },
  render() {
    const buttonStyle = this.state.listView ? styles.mapView : styles.listView;
    return <button className={`${styles.exploreMapSwitch} ${buttonStyle}`} onClick={this.handleClick} />;
  }
});

MobileExploreMapSwitch.defaultProps = {
  messagingChannel: postal.channel('explore_messagingChannel')
};

export default MobileExploreMapSwitch;
